<template>
  <div class="min-h-screen bg-gray-50">
    <SimpleHeader
      :on-close="close"
      :pages="[]"
    /><RouterView /><SimpleFooter :horizontal="true" />
  </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';

const router = useRouter();
const close = () => router.push({ name: 'BillingPage' });
</script>
